import * as types from '../_actions/actionTypes'
import _ from 'lodash'

export function contacts(state = {}, action) {
    switch (action.type) {
        case types.FETCH_CONTACTS:
            return {
                ...state,
                ...action.payload,
            }
        case types.FETCH_CONTACTS_FAILURE:
            return state
        case types.UPDATE_CONTACTS:
            return _.merge({}, state, action.payload)
        case types.UPDATE_CONTACTS_FAILURE:
            return state
        case types.REMOVE_CONTACT:
            return { contacts: _.omit(state.contacts, action.payload) }
        case types.REMOVE_CONTACT_FAILURE:
            return state
        default:
            return state
    }
}